<template>
  <div>
    <!-- 部长确认 -->
    <el-dialog :title="$t('message.ministerConfirmsReply')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center>
      <div class="content">
        <!-- 部长确认 -->
        <div class="row">
          <div class="val">
            <el-input type="textarea" v-model="datas.content"
              :placeholder="$t('message.ministerConfirmsReply')"></el-input>
          </div>
        </div>
        <!-- *是否纳入考核 -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.isIncludedInAssessment') }} :
          </div>
          <div class="val" style="line-height: 40px;">
            <!-- 是 -->
            <el-radio v-model="datas.performance_status" :label="1">{{ $t('message.are') }}</el-radio>
            <!-- 否 -->
            <el-radio v-model="datas.performance_status" :label="2">{{ $t('message.no') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      dialogVisible: false,

      datas: {
        id: '',
        type: '',
        content: '',

      },
    };
  },
  methods: {

    // 保存
    save() {

      this.$api.siteConfiguration.toDepartReConfirmed(this.datas).then(res => {
        this.dialogVisible = false
        if (this.datas.type == 'RC') {
          this.$parent.rakuchatMessageListComplain()
        } else {
          this.$parent.cwMessageListComplain()
        }
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 118px;
      margin-right: 20px;
    }

    .val {
      flex: 3;

      p {
        margin-top: 20px;
      }
    }
  }



}
</style>
